import { useGraphql } from 'utils/hooks/useGraphql';

import { fetchWorkflowCampaignNodesQuery } from 'api/queries/workflowIndex';
import { GraphQLWorkflowNodeResourceFilter } from 'modules/workflows/constants/nodeAnalytics/enums';

import {
  GraphQLWorkflowCampaignNodeMetadataQueryResponse,
  GraphQLWorkflowCampaignNodeMetadataQueryVariables,
  WorkflowId,
  WorkflowType,
} from '../types';

export const useWorkflowCampaignNodeMetadata = ({
  workflowId,
  workflowType,
}: {
  workflowId: WorkflowId;
  workflowType?: WorkflowType;
}) => {
  const { networkStatus, error, data } = useGraphql<
    GraphQLWorkflowCampaignNodeMetadataQueryResponse,
    GraphQLWorkflowCampaignNodeMetadataQueryVariables
  >(fetchWorkflowCampaignNodesQuery, {
    variables: {
      workflowId,
      workflowType,
      nodeResources: [GraphQLWorkflowNodeResourceFilter.Campaign],
    },
  });

  const isLoading = networkStatus < 7;
  const didError = !!error;
  const { allNodes = [], edges = [], startNode } = data?.workflow || {};

  return {
    isLoading,
    didError,
    allNodes,
    edges,
    startNode,
  };
};
